import { getUserData } from 'app/main/apps/contacts/store/actions/user.actions';
import axios from 'axios';
import { socket } from 'context/socket';
import * as Actions from 'app/store/actions';
import * as HELPER from 'context/helper'

export const PROJECT_SELECT_API = '[PROJECTS] GET PROJECTS SELECT API';
export const GET_PROJECTS = '[PROJECTS] GET PROJECTS';
export const RESET_GET_PROJECTS = '[PROJECTS] RESET GET PROJECTS';
export const CREATE_PROJECTS = '[PROJECTS] CREATE PROJECTS';
export const UPDATE_PROJECT = '[PROJECTS] UPDATE PROJECTS'
export const ZIPCODE_BASE_API = '[PROJECTS] ZIP CODE BASE API';
export const PROJECTS_GET_PROJECT_BRANCH = '[PROJECTS] GET PROJECT BRANCH';
export const PROJECTS_GET_PROJECT_TYPE = '[PROJECTS] GET PROJECT TYPE';
export const SET_SEARCH_TEXT = '[CONTACTS APP] SET SEARCH TEXT';
export const OPEN_NEW_CONTACT_DIALOG = '[CONTACTS APP] OPEN NEW CONTACT DIALOG';
export const CLOSE_NEW_CONTACT_DIALOG = '[CONTACTS APP] CLOSE NEW CONTACT DIALOG';
export const OPEN_EDIT_CONTACT_DIALOG = '[CONTACTS APP] OPEN EDIT CONTACT DIALOG';
export const CLOSE_EDIT_CONTACT_DIALOG = '[CONTACTS APP] CLOSE EDIT CONTACT DIALOG';
export const ADD_CONTACT = '[CONTACTS APP] ADD CONTACT';
export const UPDATE_CONTACT = '[CONTACTS APP] UPDATE CONTACT';
export const REMOVE_CONTACT = '[CONTACTS APP] REMOVE CONTACT';
export const REMOVE_CONTACTS = '[CONTACTS APP] REMOVE CONTACTS';
export const TOGGLE_STARRED_CONTACT = '[CONTACTS APP] TOGGLE STARRED CONTACT';
export const TOGGLE_STARRED_CONTACTS = '[CONTACTS APP] TOGGLE STARRED CONTACTS';
export const SET_CONTACTS_STARRED = '[CONTACTS APP] SET CONTACTS STARRED ';
export const HANDLE_PROJECTS_DATA_DETAILS = '[CONTACTS APP] HANDLE DATA DETAILS';
export const HANDLE_ENTITIES = '[CONTACTS APP] SET LINKED MEMBERS';
export const SEARCH_MEMBERS = '[CONTACTS APP] SET SEARCH MEMBERS';
export const SET_FILTER_CHECKBOX = '[CONTACTS APP] SET SEARCH FILTER PROJECTS';
export const HANDLING_FILTERED_DATA = '[CONTACTS APP] HANDLING FILTERED DATA';
export const FILES_ATTACHMENT = '[CONTACTS APP] FILES ATTACHED';
export const REMOVE_PROJECT_FILE_FROM_UPDATE = '[CONTACTS APP] REMOVE PROJECT FILE FROM UPDATE';
export const STATUS_PROJECT = '[PROJECTS] CHANGE STATUS OF PROJECT';
export const SET_BUTTON_DISPATCH_ZIPCODE = '[PROJECTS] SET BUTTON DISPATCH ZIPCODE';
export const ONDRAG_LAT_LNG = '[PROJECTS] SET LAT AND LNG FROM ONDRAG';
export const REMOVE_USER_FROM_PROJECT_SELECTED_PROJECT_PAGE = '[PROJECTS] REMOVE MEMBER FROM PROJECT SELECTED';
export const HANDLING_RESPONSE_PROJECTS_PAGE = '[PROJECTS] HANDLING RESPONSE PROJECTS PAGE';
export const PROJECT_PAGE_CLICK_FLAG = '[PROJECTS] HANDLING FLAG CLICK';
export const GET_MEMBERS_MAPPING_FROM_PROJECTS = '[PROJECTS] GETTING MEMBERS TO MAP';
export const ADD_MEMBER_MAPPING_FROM_PROJECTS = '[PROJECTS] ADD MAPPED MEMBERS FROM PROJECTS';



//::PROJECT SELECT
export function projectSelectAPI(_companyID, pageData, _searchText) {

	if(_companyID === null){
		const data = [];
		return{
			type: PROJECT_SELECT_API,
			payload: data
		}
	}else{
		return async(dispatch)=>{
			let current_user = JSON.parse(localStorage.getItem('current_user'));
			let token = current_user['authToken'];
			//let localStoragePage = localStorage.getItem('pageData');
			//let page = localStoragePage ? localStoragePage : 1;
			let searchText = _searchText;
			const companyID = _companyID;
			const headersToken = {
				'Content-Type': 'application/json',
				headers: {"Authorization": `Token ${token}`}
			};
	
			// if(pageData){
			// 	page = pageData;
			// }
	
			if(!searchText){
				searchText = '';
			}
	
			const request = axios.get(process.env.REACT_APP_SERVER + '/api/project/project-list?companyID=' + companyID +'&search=' + searchText, headersToken);
			
			return request.then(response => {
				//console.log('GET PROJECTS SELECT Succesfully', response.data);
				//history.push({ pathname: '/members' });
				return dispatch({
					type: PROJECT_SELECT_API,
					payload: response.data,
				});
			}).catch( error =>{
				//console.log('Could not load data from GET PROJECTS SELECT', error.response)
			})
		}
	}
	
}

//::GET PROJECTS
export function getProjects(_companyID, pageData, _searchText) {
	return async(dispatch)=>{
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		let localStoragePage = localStorage.getItem('pageData');
		let page = localStoragePage ? localStoragePage : 1;
		let searchText = _searchText;
		const companyID = _companyID;
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		if(pageData){
			page = pageData;
		}

		if(!searchText){
			searchText = '';
		}
		
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/project/create-update-project?companyID=' + companyID + '&page=' + page +'&search=' + searchText, headersToken);
		
		return request.then(response => {
			//console.log('GET PROJECTS Succesfully Here', response.data);
			//history.push({ pathname: '/members' });
			return dispatch({
				type: GET_PROJECTS,
				payload: response.data,
			});
		}).catch( error =>{
			console.log('Could not load data from PROJECTS', error.response)
		})
	}
}

//::Reset Projects
export function resetGetProjects(){
	return{
		type: RESET_GET_PROJECTS,
	}
}

//::Create Projects
export function createProjects(data){
	return async (dispatch)=>{
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const request = axios.post(process.env.REACT_APP_SERVER + '/api/project/create-update-project', data, headersToken );
		return request.then(response => {
			//console.log('Create PROJECTS Succesfully', response.data.data);
			dispatch(getProjects(data.companyID));
			dispatch(handlingResponseProjectsPage(true));
			return dispatch({
				type: CREATE_PROJECTS,
				payload: response.data.data,
			});
		}).catch( error =>{
			//console.log('Could Not Create PROJECTS', error.response);
			dispatch(handlingResponseProjectsPage(false));
		})
	}
}

//::Update Projects
export function updateProject(data, companyIDdata, uuid, index){
	return async (dispatch) =>{
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			enctype: 'multipart/form-data',
			headers: {"Authorization": `Token ${token}`}
		};
		//console.log('INSIDE UPDATE ACTIONS ==', data , companyIDdata);
		const request = axios.put(process.env.REACT_APP_SERVER + '/api/project/create-update-project?uuid=' + uuid, {
			...data,
			companyID:      companyIDdata,
		}, headersToken );

		return request.then((response) => {
			//console.log('Project Updated Succesfully!', response.data);
			//::Force Update Consume API
			dispatch(getProjects(companyIDdata));
			dispatch(handlingResponseProjectsPage(true));
			dispatch(Actions.highlightRow(index))
			return dispatch({
				type: UPDATE_PROJECT,
				payload: data,
			})
		})
		.catch((error => {
			console.log('Error, could not Update Project.', error.response);
			dispatch(handlingResponseProjectsPage(false));
		}))
	}
}


//::ZipCodeBase API
export function zipCodeBaseAPI(zipCodedata, countryValueData){
	console.log("zipCodeBaseAPI>>>>>>>>>")
	return async (dispatch)=>{
		// const headersToken = {
		// 	'Content-Type': 'application/json, text/plain',
		// 	headers: {"Authorization": `Token ${token}`}
		// };
		const codes = zipCodedata
		const country = countryValueData
		//let current_user = JSON.parse(localStorage.getItem('current_user'));
		//let token = current_user['authToken'];
		////console.log('APIKEY:', apiKey, 'CODES:', codes );

		//Node JS
		socket.emit("search_zip", {
			codes:codes,
			country:country,
			authToken: HELPER.getAuthToken()
		});

		socket.on('get_zip_results', (data) => {
			// we get settings data and can do something with it
			console.log('FROM ACTIONS ===>',data)
			return dispatch({
				type: ZIPCODE_BASE_API,
				payload: data,
			});
		})

		/*const request = axios.get('https://app.zipcodebase.com/api/v1/search?apikey=' + apiKey + '&codes=' + codes + '&country=' + country, {
			headers: config
		});
		//https://app.zipcodebase.com/api/v1/search?apikey=8e63bfe0-c132-11ec-889d-2959e8ef3013&codes=2030044

		return request.then(response =>{
			//console.log('ZIP CODE BASE Get Successfully !', response.data);
			return dispatch({
				type: ZIPCODE_BASE_API,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could Not Load ZIP CODE BASE API', error)
		})
		*/
	}
}

//::Get Project Branch
export function projects_getProjectBranch(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const companyID = data
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/common-type-private?companyID=' + companyID + '&type=ProjectBranch' , headersToken)
		
		return request.then(response => {
			console.log('Load Projects - Project Branch Succesfully', response.data);
			return dispatch({
				type: PROJECTS_GET_PROJECT_BRANCH,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not load data from Projects - Project Branch Error', error);
		})
	};	
}

//::Get Project Type
export function projects_getProjectType(data) {
	return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};

		const companyID = data
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/common-type-private?companyID=' + companyID + '&type=ProjectType' , headersToken)
		
		return request.then(response => {
			console.log('Load Projects - Project Type Succesfully', response.data);
			return dispatch({
				type: PROJECTS_GET_PROJECT_TYPE,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not load data from Projects - Project Type Error', error);
		})
	};	
}

//::Activate and Deactivate Project
export function statusProject(data, isDeleted) {
	return async(dispatch)=>{
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		//console.log('STATUS MEMBER --->', data, isDeleted)
		const companyID = data.companyID;
		
		const request = axios.patch(process.env.REACT_APP_SERVER + '/api/project/create-update-project?companyID=' + companyID,
		{
			...data,
			companyID : data.companyID,
			uuid: data.uuid,
			is_deleted: isDeleted,
			// type: 'Master Admin',
		}, headersToken)
		
		return request.then(response => {
			//console.log('Change Status Project Succesfully', response.data);
			dispatch(getProjects(data.companyID))
			//history.push({ pathname: '/members' });
			return dispatch({
				type: STATUS_PROJECT,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not change status from Projects', error.response)
		})
	}
}

//::Files Attachment
export function filesAttachment(data){
	////console.log('RECEBIDO NO ACTIONS ATTACHMENT:', data)
	return{
		type: FILES_ATTACHMENT,
		payload: data
	}
}

//::Remove File Update
export function removeProjectFileUpdate(data){
	return{
		type: REMOVE_PROJECT_FILE_FROM_UPDATE,
		payload: data
	}
}

//::Latitude and Longitude from OnDrag
export function onDragLatLng(data){
	return{
		type: ONDRAG_LAT_LNG,
		payload: data,
	}
}


//::Flag Button ZipCode
export function setBtnDispatchZipCode(data){
	return{
		type: SET_BUTTON_DISPATCH_ZIPCODE,
		payload: data,
	}
}

//::Remove User from Project Selected - From Projects SideBar
export function removeUserFromProjectSelected_projectPage(data){
	return async(dispatch)=>{
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		////console.log('DATA INSIDE REMOVE : ', data);
		const request = axios.patch(process.env.REACT_APP_SERVER + '/api/projectMap/create-update-project-mapping',
		{
			...data,
			companyID : data.companyID,
			user_uuid: data.userUUID,
			project_uuid: data.projectUUID,
		}, headersToken)
		
		return request.then(response => {
			//console.log('Removed from Project Succesfully', response.data);
			dispatch(getProjects(data.companyID));
			dispatch(getMembersMappingfromProjects(data.companyID, data.projectUUID));
			dispatch(handlingResponseProjectsPage(true));
			//history.push({ pathname: '/members' });
			return dispatch({
				type: REMOVE_USER_FROM_PROJECT_SELECTED_PROJECT_PAGE,
				payload: response.data,
			});
		}).catch( error =>{
			dispatch(handlingResponseProjectsPage(false));
			//console.log('Could not be Removed from Project', error)
		})
	}
}


//::Get Users from Mapping 
export function getMembersMappingfromProjects(companyIDdata, projectUUID, _pageCount) {
	return async(dispatch)=>{
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		const companyID = companyIDdata;
		let project_uuid = projectUUID;
		let pageCount = _pageCount;

		if(_pageCount === null || _pageCount === undefined){
			pageCount = 1
		}

		if(project_uuid === undefined || project_uuid === null){
			project_uuid = '';
		};

		const request = axios.get(process.env.REACT_APP_SERVER + '/api/projectMap/create-update-project-mapping?companyID=' + companyID + '&project_uuid=' + project_uuid + '&page=' + pageCount, headersToken)
		
		return request.then(response => {
			//console.log('GET Mapping Members Succesfully', response.data);
			return dispatch({
				type: GET_MEMBERS_MAPPING_FROM_PROJECTS,
				payload: response.data,
			});
		}).catch( error =>{
			//console.log('Could not load data from Mapping Members', error.response)
		})
	}
}



//::Post Add Users from Mapping
export function addMemberMappingFromProjects(data, companyIDdata, projectUUIDdata){
	return async (dispatch) =>{
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		
		const companyID = companyIDdata;
		const project_uuid = projectUUIDdata;
		const users = data;

		////console.log('INSIDE ACTIONS DATA MAPPING', data)

		const request = axios.post(process.env.REACT_APP_SERVER + '/api/projectMap/create-update-project-mapping', 
		{
			companyID: companyID,  
			project_uuid: project_uuid,
			users : users
		}, headersToken);

		return request.then((response) => {
			//console.log('Added Users Members Mapping from Projects Succesfully!', response.data);
			dispatch(getMembersMappingfromProjects(companyID, project_uuid));
			//::Force Update Consume API
			dispatch(getProjects(companyIDdata));

			dispatch(handlingResponseProjectsPage(true));
			return dispatch({
				type: ADD_MEMBER_MAPPING_FROM_PROJECTS,
				payload: data,
			})
		})
		.catch((error => {
			//dispatch(addPostMember(error.response));
			dispatch(handlingResponseProjectsPage(false));
			//console.log('Error, could not Add Users Member Mapping From Projects Page.', error.response);
		}))
	}
}












//::Handling Response 
export function handlingResponseProjectsPage(data){
	return{
		type: HANDLING_RESPONSE_PROJECTS_PAGE,
		payload: data
	}
}

//Click Flag Project Page
export function projectPageClickFlag(data){
	return{
		type: PROJECT_PAGE_CLICK_FLAG,
		payload: data
	}
} 


export function handlingFilteredData(data){
	return{
		type: HANDLING_FILTERED_DATA,
		payload: data
	}
}

export function searchFilterCheckbox(data) {
	return {
		type: SET_FILTER_CHECKBOX,
		payload: data
	};
}

export function handleEntities(data) {
	return {
		type: HANDLE_ENTITIES,
		payload: data,
	};
}

export function handleProjectsDataDetails(data) {
	return {
		type: HANDLE_PROJECTS_DATA_DETAILS,
		payload: data,
	};
}

export function setSearchText(event) {
	return {
		type: SET_SEARCH_TEXT,
		searchText: event.target.value
	};
}

export function searchMembers(event) {
	return {
		type: SEARCH_MEMBERS,
		searchMembers: event.target.value
	};
}

export function openNewContactDialog() {
	return {
		type: OPEN_NEW_CONTACT_DIALOG
	};
}

export function closeNewContactDialog() {
	return {
		type: CLOSE_NEW_CONTACT_DIALOG
	};
}

export function openEditContactDialog(data) {
	return {
		type: OPEN_EDIT_CONTACT_DIALOG,
		data
	};
}

export function closeEditContactDialog() {
	return {
		type: CLOSE_EDIT_CONTACT_DIALOG
	};
}

export function addContact(newContact) {
	return (dispatch, getState) => {
		const { routeParams } = getState().projectsApp.contacts;

		const request = axios.post('/api/contacts-app/add-contact', {
			newContact
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: ADD_CONTACT
				})
			]).then(() => dispatch(getProjects(routeParams)))
		);
	};
}

export function updateContact(contact) {
	return (dispatch, getState) => {
		const { routeParams } = getState().projectsApp.contacts;

		const request = axios.post('/api/contacts-app/update-contact', {
			contact
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: UPDATE_CONTACT
				})
			]).then(() => dispatch(getProjects(routeParams)))
		);
	};
}

export function removeContact(contactId) {
	return (dispatch, getState) => {
		const { routeParams } = getState().projectsApp.contacts;

		const request = axios.post('/api/contacts-app/remove-contact', {
			contactId
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: REMOVE_CONTACT
				})
			]).then(() => dispatch(getProjects(routeParams)))
		);
	};
}

export function removeContacts(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().projectsApp.contacts;

		const request = axios.post('/api/contacts-app/remove-contacts', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: REMOVE_CONTACTS
				})
			]).then(() => dispatch(getProjects(routeParams)))
		);
	};
}

export function toggleStarredContact(contactId) {
	return (dispatch, getState) => {
		const { routeParams } = getState().projectsApp.contacts;

		const request = axios.post('/api/contacts-app/toggle-starred-contact', {
			contactId
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: TOGGLE_STARRED_CONTACT
				}),
				dispatch(getUserData())
			]).then(() => dispatch(getProjects(routeParams)))
		);
	};
}

export function toggleStarredContacts(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().projectsApp.contacts;

		const request = axios.post('/api/contacts-app/toggle-starred-contacts', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: TOGGLE_STARRED_CONTACTS
				}),
				dispatch(getUserData())
			]).then(() => dispatch(getProjects(routeParams)))
		);
	};
}

export function setContactsStarred(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().projectsApp.contacts;

		const request = axios.post('/api/contacts-app/set-contacts-starred', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: SET_CONTACTS_STARRED
				}),
				dispatch(getUserData())
			]).then(() => dispatch(getProjects(routeParams)))
		);
	};
}

export function setContactsUnstarred(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().projectsApp.contacts;

		const request = axios.post('/api/contacts-app/set-contacts-unstarred', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: SET_CONTACTS_STARRED
				}),
				dispatch(getUserData())
			]).then(() => dispatch(getProjects(routeParams)))
		);
	};
}